/* ROK · comparateur de pré-workouts, scoop contre scoop.
   Trois entrées : case VS animée (fiche, accueil), lien du panneau d'achat, adresse #vs-<id>.
   Une seule fenêtre construite à la première ouverture ; la page dédiée utilise le même moteur.
   Règles de calcul et sources : commerce/pre-workout-comparator.md. */
(() => {
  const dataEl = document.getElementById('rok-cmp-data');
  if (!dataEl || window.__rokCompare) return;
  window.__rokCompare = true;
  const D = JSON.parse(dataEl.textContent);
  const ROK = D.rok, RIVALS = D.rivals;
  /* Textes du comparateur selon la langue de la page (fr ou en) */
  const LANG = (document.documentElement.lang || 'fr').toLowerCase().startsWith('fr') ? 'fr' : 'en';
  const T = {
    fr: {
      beta: 'Bêta-alanine', caffeine: 'Caféine',
      market: {eu: 'Vendu dans l’UE', us: 'Vendu aux États-Unis', uk: 'Vendu au Royaume-Uni'},
      choose: 'Choisir un pré-workout', searchPh: 'Cherche ton pré-workout', searchLbl: 'Chercher un pré-workout', closeList: 'Fermer la liste', listLbl: 'Pré-workouts',
      empty: 'Pas encore dans la liste. On l’ajoute dès que son étiquette est vérifiée.', method: 'Méthode', methodTitle: 'Scoop contre scoop',
      methodText: 'Un scoop complet selon chaque étiquette. Seuls les cinq actifs de ROK sont comparés. Prix catalogue UE d’un pot, hors promo, pack et port.',
      arena: 'Comparatif par scoop', ratioCap: 'fois plus d’actifs par scoop', ratioCapFor: b => `fois plus d’actifs par scoop pour ${b}`, rowsLbl: 'Actifs par scoop',
      change: 'Changer de pré-workout', prev: 'Pré-workout précédent', next: 'Pré-workout suivant', swap: 'Changer',
      dealLbl: 'Le prix, rapporté aux actifs', tagsLbl: 'Prix au kilo d’actifs', cheaper: 'Moins cher', perKg: 'le kilo d’actifs',
      perKgConv: c => `le kilo d’actifs · converti depuis ${c === 'USD' ? 'le dollar' : 'la livre'}`,
      mail: n => `Reçois <b data-mail-vs>${n}</b> par email.`, vsYour: 'ROK vs ton pré',
      tub: '1 pot', add: 'Ajouter au sac',
      capPill: 'Plafond légal FR · hors match', capWhy: 'Pourquoi hors match', capTitle: '200 mg, c’est le maximum',
      capText: 'En France, un complément alimentaire ne peut pas dépasser 200 mg de caféine par portion journalière (arrêté du 26 septembre 2016). ROK est au plafond autorisé. Les milligrammes au-dessus ne comptent pas : ni victoire, ni défaite.',
      base: (b, src) => `Base : ${b}. ${src}.`, official: (a, sym) => ` Prix officiel ${a} ${sym}, converti au taux BCE du 02/10/2026.`,
      whyConv: 'Pourquoi on convertit', malText: 'La citrulline malate mélange citrulline et acide malique',
      malPure: ' : l’étiquette donne la part de citrulline, on prend ce chiffre.', malRatio: ' : en 2:1, environ deux tiers seulement sont de la citrulline. On ramène l’étiquette au niveau de notre citrulline pure.',
      malAssumed: ' Ratio non précisé sur l’étiquette : 2:1 retenu.', malDecl: (d, v) => `${d} malate, dont ${v} de citrulline (déclaré)`, malCalc: (d, v) => `${d} malate × 2/3 ≈ ${v} pure`,
      scoopLine: (pr, g) => `Scoop ${pr} · ${g} d’actifs`, actives: 'd’actifs',
      winLine: (pc, b) => `Au kilo d’actifs, ROK coûte <b>${pc} % de moins</b> que ${b}.`,
      same: b => `Au kilo d’actifs, ROK et ${b} coûtent pareil.`, loseLine: (b, pc) => `Au kilo d’actifs, ${b} coûte <b class="is-lose">${pc} % de moins</b>.`,
      loseSub: x => `Mais un scoop ROK contient ${x} fois plus d’actifs.`, conv: c => ` Prix ${c === 'USD' ? 'américain' : 'britannique'} converti : port, douane et TVA en plus.`,
      known: 'Les plus connus', all: 'Toute la liste', count: n => n + ' pré-workouts',
      mailOk: n => ` On t’envoie ROK vs ${n}, puis l’ouverture ROK en premier.`,
      wallOpen: n => `Comparer ${n} avec ROK`
    },
    en: {
      beta: 'Beta-alanine', caffeine: 'Caffeine',
      market: {eu: 'Sold in the EU', us: 'Sold in the US', uk: 'Sold in the UK'},
      choose: 'Choose a pre-workout', searchPh: 'Find your pre-workout', searchLbl: 'Search pre-workouts', closeList: 'Close the list', listLbl: 'Pre-workouts',
      empty: 'Not on the list yet. We add it as soon as its label is checked.', method: 'Method', methodTitle: 'Scoop for scoop',
      methodText: 'One full scoop as stated on each label. Only ROK’s five actives are compared. EU list price of one tub, excluding offers, bundles and delivery.',
      arena: 'Scoop-for-scoop comparison', ratioCap: 'times more actives per scoop', ratioCapFor: b => `times more actives per scoop for ${b}`, rowsLbl: 'Actives per scoop',
      change: 'Change pre-workout', prev: 'Previous pre-workout', next: 'Next pre-workout', swap: 'Change',
      dealLbl: 'Price per gram of actives', tagsLbl: 'Price per kilo of actives', cheaper: 'Cheaper', perKg: 'per kilo of actives',
      perKgConv: c => `per kilo of actives · converted from ${c === 'USD' ? 'dollars' : 'pounds'}`,
      mail: n => `Get <b data-mail-vs>${n}</b> by email.`, vsYour: 'ROK vs your pre',
      tub: '1 tub', add: 'Add to bag',
      capPill: 'French legal cap · not scored', capWhy: 'Why not scored', capTitle: '200 mg is the maximum',
      capText: 'In France, a food supplement cannot exceed 200 mg of caffeine per daily serving (decree of 26 September 2016). ROK sits at the cap. Milligrams above it don’t count: no win, no loss.',
      base: (b, src) => `Basis: ${b}. ${src}.`, official: (a, sym) => ` Official price ${sym}${a}, converted at the ECB rate of 02/10/2026.`,
      whyConv: 'Why we convert', malText: 'Citrulline malate mixes citrulline and malic acid',
      malPure: ': the label gives the citrulline share, so we use that number.', malRatio: ': at 2:1, only about two thirds is citrulline. We bring the label down to the level of our pure citrulline.',
      malAssumed: ' Ratio not stated on the label: 2:1 assumed.', malDecl: (d, v) => `${d} malate, of which ${v} citrulline (declared)`, malCalc: (d, v) => `${d} malate × 2/3 ≈ ${v} pure`,
      scoopLine: (pr, g) => `Scoop ${pr} · ${g} of actives`, actives: 'of actives',
      winLine: (pc, b) => `Per kilo of actives, ROK costs <b>${pc}% less</b> than ${b}.`,
      same: b => `Per kilo of actives, ROK and ${b} cost the same.`, loseLine: (b, pc) => `Per kilo of actives, ${b} costs <b class="is-lose">${pc}% less</b>.`,
      loseSub: x => `But a ROK scoop holds ${x} times more actives.`, conv: c => ` ${c === 'USD' ? 'US' : 'UK'} price converted: delivery, customs and VAT on top.`,
      known: 'Best known', all: 'Full list', count: n => n + ' pre-workouts',
      mailOk: n => ` We’ll send you ROK vs ${n}, then the ROK launch first.`,
      wallOpen: n => `Compare ${n} with ROK`
    }
  }[LANG];
  /* Données concurrents rédigées en français : version anglaise des mentions récurrentes */
  const DATA_EN = [[/étiquette publiée par le revendeur/g, 'label published by the reseller'], [/étiquette lue le/g, 'label read on'], [/étiquette lue/g, 'label read'],
    [/vendu en dollars/g, 'sold in US dollars'], [/vendu en livres \(Royaume-Uni\)/g, 'sold in pounds (UK)'], [/vendu en livres/g, 'sold in pounds'],
    [/relevé du/g, 'checked on'], [/prix à revérifier/g, 'price to recheck'], [/page illisible le/g, 'page unreadable on'], [/\(revendeur\)/g, '(reseller)'],
    [/prix barré ([\d,]+)[\s ]?€ \(([\d,]+)[\s ]?€ en promo le ([\d/]+)\)/g, (m, a, b, d) => `list price €${a.replace(',', '.')} (€${b.replace(',', '.')} on offer on ${d})`],
    [/Boutique (\w+) UE/g, '$1 EU store'], [/Version UE/g, 'EU version'], [/tyrosine en N-acétyl-L-tyrosine/g, 'tyrosine as N-acetyl-L-tyrosine'], [/tyrosine en N-acétyl/g, 'tyrosine as N-acetyl'],
    [/malate de dicaféine/g, 'dicaffeine malate'], [/caféine ≈/g, 'caffeine ≈'], [/caféine/g, 'caffeine'], [/citrate et malate/g, 'citrate and malate'], [/sachet de/g, 'sachet of'], [/tableau/g, 'table'],
    [/fiche du ([\d/]+) et page du ([\d/]+)/g, 'product sheet of $1 and page of $2'], [/ dans /g, ' in '], [/ g de /g, ' g of '], [/colonne de l’étiquette UE/g, 'EU label column'],
    [/le fabricant met en avant (\d) scoops/g, 'the brand pushes $1 scoops'], [/(\d) scoops possibles/g, '$1 scoops possible'], [/\bdose\b/g, 'serving'], [/\bsachet\b/g, 'sachet'],
    [/(\d),(\d)/g, '$1.$2']];
  const dataTxt = v => LANG === 'fr' ? v : DATA_EN.reduce((t, [re, to]) => t.replace(re, to), String(v));
  const ACTIVES = [
    {id: 'citrulline', name: 'Citrulline', unit: 'g'},
    {id: 'beta', name: T.beta, unit: 'g'},
    {id: 'taurine', name: 'Taurine', unit: 'g'},
    {id: 'tyrosine', name: 'Tyrosine', unit: 'g'},
    {id: 'caffeine', name: T.caffeine, unit: 'mg', cap: 200}
  ];
  /* Citrulline malate : teneur pure déclarée si l'étiquette la donne, sinon 2:1 → deux tiers (méthode du benchmark ROK). */
  RIVALS.forEach(p => { if (p.malate) p.doses.citrulline = p.malate.pure ?? p.malate.declared * 2 / 3; });
  /* Produits vendus hors UE : prix catalogue officiel converti au taux de référence BCE (voir pre-workout-comparator.md). */
  const SYM = {USD: '$', GBP: '£'};
  RIVALS.forEach(p => { if (p.price == null && p.local && D.fx?.[p.local.cur]) { p.price = p.local.amount / D.fx[p.local.cur]; p.converted = true; } });
  /* Marché de vente en drapeau SVG (les drapeaux emoji ne s'affichent pas sous Windows). */
  const FLAG = {
    eu: '<svg viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#003399"/>' + Array.from({length: 12}, (_, k) => { const a = k * Math.PI / 6; return `<circle cx="${(15 + 6 * Math.sin(a)).toFixed(2)}" cy="${(10 - 6 * Math.cos(a)).toFixed(2)}" r=".9" fill="#FFCC00"/>`; }).join('') + '</svg>',
    us: '<svg viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#fff"/>' + Array.from({length: 7}, (_, k) => `<rect y="${(k * 40 / 13).toFixed(2)}" width="30" height="${(20 / 13).toFixed(2)}" fill="#B22234"/>`).join('') + '<rect width="12" height="10.77" fill="#3C3B6E"/></svg>',
    uk: '<svg viewBox="0 0 30 20" aria-hidden="true"><rect width="30" height="20" fill="#012169"/><path d="M0 0L30 20M30 0L0 20" stroke="#fff" stroke-width="4"/><path d="M0 0L30 20M30 0L0 20" stroke="#C8102E" stroke-width="1.6"/><path d="M15 0V20M0 10H30" stroke="#fff" stroke-width="6"/><path d="M15 0V20M0 10H30" stroke="#C8102E" stroke-width="3.6"/></svg>'
  };
  const MARKET = T.market;
  const flag = p => `<span class="rc-flag" title="${MARKET[p.market]}" role="img" aria-label="${MARKET[p.market]}">${FLAG[p.market] || ''}</span>`;
  const money = v => LANG === 'fr' ? v.toFixed(2).replace('.', ',') : v.toFixed(2);
  const byId = id => RIVALS.find(r => r.id === id);

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const U = ' ', E = LANG === 'fr' ? ' €' : '';
  const eur = s => LANG === 'fr' ? s + ' €' : '€' + s;
  const num = (v, d = 1) => { const t = (Math.round(v * 10 ** d) / 10 ** d).toString(); return LANG === 'fr' ? t.replace('.', ',') : t; };
  const fmt = (v, unit) => unit === 'mg' ? Math.round(v) + U + 'mg' : num(v) + U + 'g';
  const gramsTxt = v => num(v, v < 10 ? 2 : 1) + U + 'g';
  const euro = v => eur(money(Math.round(v * 100 + 1e-9) / 100));
  /* Les mg de caféine au-dessus du plafond français ne comptent pas dans les totaux */
  const grams = p => ACTIVES.reduce((s, a) => s + (a.unit === 'mg' ? Math.min(p.doses[a.id], a.cap || Infinity) / 1000 : p.doses[a.id]), 0);
  const perEuro = p => grams(p) / (p.price / p.servings);
  const esc = v => String(v).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));

  /* Le pré choisi est retenu pour que la case VS reparte de lui à la visite suivante. */
  const remember = id => { try { localStorage.setItem('rok-cmp-rival', id); } catch {} };
  const remembered = () => { try { const id = localStorage.getItem('rok-cmp-rival'); return byId(id) ? id : null; } catch { return null; } };

  /* Mesure : ouverture, changement de pré, inscription, clic vers l'achat. */
  const track = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent('rok:compare', {detail: {name, ...detail}}));
    try { window.Shopify?.analytics?.publish?.('rok_compare_' + name, detail); } catch {}
    try { (window.dataLayer = window.dataLayer || []).push({event: 'rok_compare_' + name, ...detail}); } catch {}
  };

  function countTo(el, from, to, render, dur = 800) {
    if (reduce) { el.textContent = render(to); return; }
    const t0 = performance.now();
    const step = t => { const k = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = render(from + (to - from) * e); if (k < 1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }

  const lock = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="3" y="7" width="10" height="7" rx="1.5"/><path d="M5.5 7V5a2.5 2.5 0 0 1 5 0v2"/></svg>';
  const arrow = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';
  const onProductPage = () => !!document.getElementById('buy-rok');

  /* 08/10 (Enzo) : une seule photo, cadrée à gauche, qui porte le titre ; contenu resserré ; noir ou blanc selon le mode du site. */
  const template = mode => `
    <div class="rc-in">
      <figure class="rc-photo">
        <img src="${esc(D.photo)}" alt="" loading="lazy">
        <figcaption><h2 class="rc-title rc-d" id="rc-title-${mode}">Read your label. <span>Then read ours.</span></h2></figcaption>
      </figure>
      <div class="rc-main">
      <header class="rc-top">
        <div class="rc-tools">
          <button type="button" class="rc-chooser" aria-haspopup="dialog" aria-expanded="false" data-chooser>
            <span class="rc-chooser-vs">VS</span><span class="rc-chooser-pot"><img data-chooser-img alt=""><span data-chooser-flag></span></span><span class="rc-chooser-nm"><small data-chooser-brand></small><b data-chooser-name></b></span><span class="rc-caret" aria-hidden="true">▾</span>
          </button>
          <div class="rc-picker" role="dialog" aria-label="${T.choose}" data-picker>
            <div class="rc-picker-head"><input type="search" placeholder="${T.searchPh}" aria-label="${T.searchLbl}" data-search><span class="rc-lbl" data-count></span><button type="button" class="rc-picker-x" aria-label="${T.closeList}" data-picker-close>×</button></div>
            <div class="rc-grid" role="listbox" aria-label="${T.listLbl}" data-grid></div>
            <p class="rc-empty" data-empty hidden>${T.empty}</p>
          </div>
          <div class="rc-method">
            <button type="button" class="rc-info-trigger" aria-expanded="false"><span class="rc-info" aria-hidden="true">i</span><span class="rc-txt rc-lbl">${T.method}</span></button>
            <span class="rc-bubble" role="tooltip"><b>${T.methodTitle}</b>${T.methodText}<em data-source></em></span>
          </div>
        </div>
      </header>
      <section class="rc-arena" aria-label="${T.arena}">
        <div class="rc-side rc-side-rok">
          <div class="rc-pot"><img src="${esc(ROK.img)}" alt="ROK Pre-Workout"></div>
          <div class="rc-total rc-d rc-num" data-total-rok><span class="rc-chrome">0</span></div>
          <p class="rc-meta">ROK · ${euro(ROK.price)} · ${ROK.servings} scoops</p>
        </div>
        <div class="rc-board">
          <div class="rc-ratio"><b class="rc-d rc-num rc-chrome" data-ratio>0</b><span class="rc-lbl" data-ratio-cap>${T.ratioCap}</span></div>
          <div data-rows role="table" aria-label="${T.rowsLbl}"></div>
        </div>
        <div class="rc-side rc-side-rival">
          <div class="rc-pot" data-open-picker title="${T.change}"><button type="button" class="rc-nav rc-prev" aria-label="${T.prev}" data-step="-1">‹</button><img data-rival-img alt=""><button type="button" class="rc-nav rc-next" aria-label="${T.next}" data-step="1">›</button><span class="rc-swap-hint rc-lbl">${T.swap}</span></div>
          <div class="rc-total rc-d rc-num" data-total-rival>0</div>
          <p class="rc-meta" data-rival-meta></p>
        </div>
      </section>
      <section class="rc-deal" aria-label="${T.dealLbl}">
        <div class="rc-deal-say">
          <p class="rc-deal-title rc-d" data-deal-title>Pay for grams.</p>
          <p class="rc-deal-line" data-deal-line></p>
          <p class="rc-deal-sub" data-deal-sub></p>
        </div>
        <div class="rc-tags" role="group" aria-label="${T.tagsLbl}">
          <div class="rc-ptag" data-tag-rok><i class="rc-badge">${T.cheaper}</i><small>ROK</small><b data-kg-rok>0</b><span class="rc-per">${T.perKg}</span><em data-scoop-rok></em></div>
          <div class="rc-ptag" data-tag-rival><i class="rc-badge">${T.cheaper}</i><small data-tag-rival-name></small><b data-kg-rival>0</b><span class="rc-per" data-per-rival>${T.perKg}</span><em data-scoop-rival></em></div>
        </div>
      </section>
      <footer class="rc-foot">
        <div class="rc-mail" data-mail>
          <button type="button" class="rc-mail-toggle" aria-expanded="false" data-mail-toggle><span class="rc-mail-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/></svg></span><span>${T.mail(T.vsYour)}</span></button>
          <div class="rc-mail-panel" data-mail-panel hidden></div>
        </div>
        <a class="rc-buy" href="${esc(D.productUrl)}?pack=1#buy-rok" data-buy><span class="rc-buy-copy"><span class="rc-d">Wake the heavy.</span><small>${T.tub} · ${euro(ROK.price)} · 20 scoops</small></span><span class="rc-buy-go">${T.add} ${arrow}</span></a>
      </footer>
      </div>
    </div>`;

  function makeRow(label, host) {
    const el = document.createElement('div'); el.className = 'rc-r'; el.setAttribute('role', 'row');
    el.innerHTML = `<span class="rc-r-name rc-lbl" role="rowheader">${label}</span>
      <span class="rc-r-flag"><span class="rc-pill">${lock}${T.capPill}</span><button class="rc-info" type="button" aria-expanded="false" aria-label="${T.capWhy}">i</button><span class="rc-bubble" role="tooltip"><b>${T.capTitle}</b>${T.capText}</span></span>
      <div class="rc-r-line"><span class="rc-v rc-v-l" role="cell"><span data-v>0</span></span><span class="rc-t rc-t-l"><i></i><span class="rc-tick"></span></span><span class="rc-t rc-t-r"><i></i><b class="rc-over"></b><span class="rc-tick"></span></span><span class="rc-v rc-v-r" role="cell"><span data-pre></span><span data-v>0</span><span data-x></span></span></div>`;
    host.appendChild(el); el._prev = [0, 0]; return el;
  }

  function setRow(el, rv, tv, {render, cap, extra = '', pre = ''}, delay) {
    const max = Math.max(rv, tv) || 1;
    const tie = rv === tv && rv > 0;
    const capped = cap && tv > cap;
    const rokWin = tie || (!capped && rv > tv), rivWin = tie || (!capped && tv > rv);
    const [bl, br] = el.querySelectorAll('.rc-t i'), [vl, vr] = el.querySelectorAll('[data-v]');
    const [vL, vR] = el.querySelectorAll('.rc-v');
    el.querySelector('[data-pre]').textContent = pre;
    el.querySelector('[data-x]').innerHTML = extra;
    el.querySelector('.rc-t-r').classList.toggle('is-absent', tv === 0);
    el.classList.toggle('is-capped', !!capped);
    if (capped) {
      const c = cap / max * 100, [tl, tr] = el.querySelectorAll('.rc-tick');
      tl.style.right = `calc(${c}% - 1px)`; tl.style.left = 'auto'; tr.style.left = `calc(${c}% - 1px)`;
      const o = el.querySelector('.rc-over'); o.style.left = c + '%'; o.style.width = (100 - c) + '%';
    }
    setTimeout(() => {
      bl.style.transform = `scaleX(${rv / max})`; br.style.transform = `scaleX(${(capped ? cap : tv) / max})`;
      countTo(vl, el._prev[0], rv, render); countTo(vr, el._prev[1], tv, render); el._prev = [rv, tv];
      const rokLose = !tie && !capped && rivWin, rivLose = !tie && !capped && rokWin;
      [[bl, rokWin, rokLose], [br, rivWin, rivLose], [vL, rokWin, rokLose], [vR, rivWin, rivLose]].forEach(([n, w, l]) => { n.classList.toggle('is-win', w); n.classList.toggle('is-lose', l); });
      el.querySelector('.rc-t-r').classList.toggle('is-lose', rivLose && tv === 0);
    }, reduce ? 0 : delay);
  }

  /* Construit un comparateur dans host. mode : 'modal' ou 'page'. */
  function build(host, mode, onChange) {
    host.innerHTML = template(mode);
    host.classList.add('rc--' + mode);
    const $ = s => host.querySelector(s), $$ = s => [...host.querySelectorAll(s)];
    const rows = ACTIVES.map(a => makeRow(a.name, $('[data-rows]')));
    let current = null, totals = [0, 0], ratioNow = 0, value = [0, 0], started = false;
    const arena = $('.rc-arena');

    function show(id) {
      const p = byId(id) || RIVALS[0];
      if (current && current.id === p.id) return;
      $$('[data-grid] .rc-card').forEach(b => b.setAttribute('aria-selected', b.dataset.id === p.id));
      $('[data-chooser-img]').src = p.img; $('[data-chooser-flag]').innerHTML = flag(p); $('[data-chooser-brand]').textContent = p.brand; $('[data-chooser-name]').textContent = p.name;
      $('[data-mail-vs]').textContent = 'ROK vs ' + p.name;
      const apply = () => {
        const img = $('[data-rival-img]');
        img.src = p.img; img.alt = `${p.brand} ${p.name}`; img.style.setProperty('--s', p.scale);
        $('[data-rival-meta]').textContent = p.converted ? `${p.brand} · ≈ ${eur(money(p.price))} (${LANG === 'fr' ? money(p.local.amount) + U + SYM[p.local.cur] : SYM[p.local.cur] + money(p.local.amount)}) · ${p.servings} scoops` : `${p.brand} · ${eur(money(p.price))} · ${p.servings} ${p.servings > 1 ? 'scoops' : 'scoop'}`;
        $('[data-source]').textContent = T.base(dataTxt(p.base), dataTxt(p.source)) + (p.converted ? T.official(money(p.local.amount), SYM[p.local.cur]) : '');
        ACTIVES.forEach((a, i) => {
          const tv = p.doses[a.id], mal = a.id === 'citrulline' && p.malate;
          const extra = mal ? `<button class="rc-info" type="button" aria-expanded="false" aria-label="${T.whyConv}">i</button><span class="rc-bubble" role="tooltip"><b>Malate ≠ pure</b>${T.malText}${p.malate.pure != null ? T.malPure : T.malRatio}${p.malate.assumed ? T.malAssumed : ''}<em>${p.malate.pure != null ? T.malDecl(fmt(p.malate.declared, 'g'), fmt(tv, 'g')) : T.malCalc(fmt(p.malate.declared, 'g'), fmt(tv, 'g'))}</em></span>` : '';
          setRow(rows[i], ROK.doses[a.id], tv, {render: v => fmt(v, a.unit), cap: a.cap, extra, pre: mal ? '≈ ' : ''}, 200 + i * 110);
        });
        /* Bande du prix : le réflexe du rayon, le prix au kilo. Une étiquette par produit, la moins chère s'allume. */
        const kg = q => q.price / q.servings / grams(q) * 1000;
        const kgR = kg(ROK), kgT = kg(p);
        const euro0 = v => LANG === 'fr' ? Math.round(v) + '<span>€</span>' : '<span>€</span>' + Math.round(v);
        const scoopLine = (q, n) => T.scoopLine(euro(q.price / q.servings), gramsTxt(n));
        const tagR = $('[data-tag-rok]'), tagT = $('[data-tag-rival]');
        const rokCheaper = Math.round(kgR) < Math.round(kgT), same = Math.round(kgR) === Math.round(kgT);
        tagR.classList.toggle('is-win', rokCheaper); tagR.classList.toggle('is-lose', !rokCheaper && !same);
        tagT.classList.toggle('is-win', !rokCheaper && !same); tagT.classList.toggle('is-lose', rokCheaper);
        $('[data-tag-rival-name]').textContent = p.brand;
        $('[data-scoop-rok]').textContent = scoopLine(ROK, grams(ROK));
        $('[data-scoop-rival]').textContent = scoopLine(p, grams(p));
        $('[data-per-rival]').textContent = p.converted ? T.perKgConv(p.local.cur) : T.perKg;
        $('[data-kg-rok]').innerHTML = euro0(kgR);
        const kT = $('[data-kg-rival]'), from = value[1] || kgT, approx = p.converted ? '≈' : '';
        if (reduce) kT.innerHTML = approx + euro0(kgT);
        else { const t0 = performance.now(); const run = t => { const k = Math.min(1, (t - t0) / 900), e = 1 - Math.pow(1 - k, 3); kT.innerHTML = approx + euro0(from + (kgT - from) * e); if (k < 1) requestAnimationFrame(run); }; setTimeout(() => requestAnimationFrame(run), 600); }
        value = [kgR, kgT];
        const xMore = num(grams(ROK) / grams(p));
        if (rokCheaper) {
          $('[data-deal-title]').textContent = 'Pay for grams.';
          $('[data-deal-line]').innerHTML = T.winLine(Math.round((1 - kgR / kgT) * 100), esc(p.brand));
          $('[data-deal-sub]').textContent = '';
        } else {
          $('[data-deal-title]').textContent = 'Read the grams.';
          $('[data-deal-line]').innerHTML = same ? T.same(esc(p.brand)) : T.loseLine(esc(p.brand), Math.round((1 - kgT / kgR) * 100));
          $('[data-deal-sub]').textContent = T.loseSub(xMore);
        }
        if (p.converted) $('[data-deal-sub]').textContent += T.conv(p.local.cur);
        const tR = grams(ROK), tT = grams(p);
        countTo($('[data-total-rok] .rc-chrome'), totals[0], tR, gramsTxt, 1000); countTo($('[data-total-rival]'), totals[1], tT, gramsTxt, 1000); totals = [tR, tT];
        $('[data-total-rival]').classList.toggle('is-lose', tT < tR);
        const ratio = Math.max(tR, tT) / Math.min(tR, tT);
        countTo($('[data-ratio]'), ratioNow, ratio, v => num(v), 1000); ratioNow = ratio;
        $('[data-ratio-cap]').textContent = tR >= tT ? T.ratioCap : T.ratioCapFor(p.brand);
      };
      const first = !current; current = p;
      if (first || reduce) { apply(); requestAnimationFrame(() => requestAnimationFrame(() => arena.classList.add('is-in'))); }
      else { arena.classList.add('is-swapping'); setTimeout(() => { apply(); requestAnimationFrame(() => arena.classList.remove('is-swapping')); }, 260); }
      if (started) { remember(p.id); onChange?.(p.id); track('switch', {rival: p.id, mode}); }
    }

    /* Grille de pots : on reconnaît le pot avant le nom */
    const picker = $('[data-picker]'), chooser = $('[data-chooser]'), search = $('[data-search]');
    RIVALS.forEach((p, i) => {
      const b = document.createElement('button'); b.type = 'button'; b.className = 'rc-card'; b.dataset.id = p.id; b.setAttribute('role', 'option');
      b.dataset.q = `${p.brand} ${p.name}`.toLowerCase(); b.style.animationDelay = (i * 30) + 'ms';
      b.innerHTML = `<span class="rc-cp"><img src="${esc(p.img)}" alt="" loading="lazy"></span><small>${esc(p.brand)}</small><b>${esc(p.name)}</b><em>${gramsTxt(grams(p))} <i>${T.actives}</i></em>${flag(p)}`;
      b.addEventListener('click', () => { openPicker(false); show(p.id); chooser.focus({preventScroll: true}); });
      if (i === 0 || i === 12) { const h = document.createElement('p'); h.className = 'rc-group rc-lbl'; h.textContent = i === 0 ? T.known : T.all; $('[data-grid]').appendChild(h); }
      $('[data-grid]').appendChild(b);
    });
    $('[data-count]').textContent = T.count(RIVALS.length);
    const isPickerOpen = () => picker.classList.contains('is-on');
    function openPicker(open) {
      picker.classList.toggle('is-on', open); chooser.setAttribute('aria-expanded', open);
      host.classList.toggle('is-picking', open);
      if (open) { search.value = ''; filter(); if (matchMedia('(hover:hover)').matches) setTimeout(() => search.focus({preventScroll: true}), 60); }
    }
    function filter() {
      const q = search.value.trim().toLowerCase(); let n = 0;
      $$('[data-grid] .rc-card').forEach(c => { const hit = !q || c.dataset.q.includes(q); c.hidden = !hit; n += hit; });
      $$('[data-grid] .rc-group').forEach(g => { g.hidden = !!q; });
      $('[data-empty]').hidden = n > 0;
    }
    search.addEventListener('input', filter);
    search.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); host.querySelector('[data-grid] .rc-card:not([hidden])')?.click(); } });
    chooser.addEventListener('click', e => { e.stopPropagation(); openPicker(!isPickerOpen()); });
    $('[data-picker-close]').addEventListener('click', () => openPicker(false));
    $('[data-open-picker]').addEventListener('click', e => { if (e.target.closest('.rc-nav')) return; e.stopPropagation(); openPicker(true); });
    const step = d => { const i = RIVALS.findIndex(r => r.id === current.id); show(RIVALS[(i + d + RIVALS.length) % RIVALS.length].id); };
    $$('.rc-nav').forEach(b => b.addEventListener('click', e => { e.stopPropagation(); step(+b.dataset.step); }));
    host.addEventListener('click', e => { if (isPickerOpen() && !e.target.closest('[data-picker]')) openPicker(false); });

    /* Bulles : ouverture au clic, fermeture au clic extérieur ou avec Échap */
    const closeBubbles = except => $$('.rc-info[aria-expanded=true], .rc-info-trigger[aria-expanded=true]').forEach(b => { if (b !== except) { b.setAttribute('aria-expanded', 'false'); b.nextElementSibling.classList.remove('is-on'); } });
    host.addEventListener('click', e => {
      const btn = e.target.closest('button.rc-info, .rc-info-trigger');
      closeBubbles(btn);
      if (btn) { const open = btn.getAttribute('aria-expanded') !== 'true'; btn.setAttribute('aria-expanded', open); btn.nextElementSibling.classList.toggle('is-on', open); }
    });

    /* Inscription facultative : jamais un passage obligé pour voir le comparatif */
    const mailToggle = $('[data-mail-toggle]'), mailPanel = $('[data-mail-panel]');
    const tpl = document.getElementById('rok-cmp-signup');
    mailToggle.addEventListener('click', () => {
      const open = mailPanel.hidden;
      if (open && !mailPanel.firstElementChild && tpl) {
        mailPanel.appendChild(tpl.content.cloneNode(true));
        const form = mailPanel.querySelector('form'), mail = form.querySelector('[data-rc-mail]'), ok = form.querySelector('[data-rc-consent]'), go = form.querySelector('[data-rc-mail-go]');
        const check = () => { go.disabled = !(mail.value && mail.validity.valid && ok.checked); };
        mail.addEventListener('input', check); ok.addEventListener('change', check);
        form.addEventListener('submit', e => {
          if (go.disabled) { e.preventDefault(); return; }
          form.querySelector('[data-rc-tags]').value = `newsletter,rok-compare,vs-${current.id}`;
          track('signup', {rival: current.id, mode});
          const real = /\/contact/.test(form.getAttribute('action') || '');
          if (real) { try { sessionStorage.setItem('rok-cmp-posted', current.id); } catch {} return; }
          e.preventDefault(); mailDone(); /* aperçu local : aucune transmission */
        });
      }
      mailPanel.hidden = !open; mailToggle.setAttribute('aria-expanded', open); host.classList.toggle('is-mail', open);
      if (open) setTimeout(() => mailPanel.querySelector('[data-rc-mail]')?.focus({preventScroll: true}), 30);
    });
    function mailDone() {
      mailPanel.hidden = false; host.classList.add('is-mail');
      mailToggle.hidden = true;
      mailPanel.innerHTML = `<p class="rc-mail-ok" role="status"><span class="rc-d">You’re on the heavy list.</span>${T.mailOk(esc(current.name))}</p>`;
    }

    /* Vers l'achat. Sur la fiche : « Ajouter au sac » met un pot dans le sac du site ; « Duo et Trio » ramène au panneau d'achat. */
    const toBuyBox = () => {
      host.closest('dialog')?.close();
      const box = document.getElementById('buy-rok');
      box.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block: 'center'});
      box.classList.remove('rc-buy-flash'); void box.offsetWidth; box.classList.add('rc-buy-flash');
      return box;
    };
    $('[data-buy]').addEventListener('click', e => {
      track('buy_click', {rival: current.id, mode, pack: 1});
      if (!onProductPage()) return;
      e.preventDefault();
      const box = toBuyBox();
      const solo = box.querySelector('input[name="rok-pack"][value="1"]'), qty = box.querySelector('#product-quantity'), add = box.querySelector('[data-add-to-cart]');
      if (solo && !solo.checked) { solo.checked = true; solo.dispatchEvent(new Event('change', {bubbles: true})); }
      if (qty) qty.value = 1;
      add ? setTimeout(() => add.click(), reduce ? 0 : 350) : null;
    });
    const ctl = {
      host, show, step, mailDone,
      start(id) { show(id); started = true; },
      get current() { return current; },
      escape() { if (host.querySelector('.rc-bubble.is-on')) { closeBubbles(); return true; } if (isPickerOpen()) { openPicker(false); chooser.focus({preventScroll: true}); return true; } return false; },
      keys(e) { if (e.target.matches('input, textarea') || isPickerOpen()) return; if (e.key === 'ArrowRight') step(1); if (e.key === 'ArrowLeft') step(-1); }
    };
    return ctl;
  }

  /* ---------- Fenêtre ---------- */
  const modal = document.querySelector('[data-rc-modal]');
  let modalCtl = null, lastFocus = null;
  const hashId = () => { const m = location.hash.match(/^#vs-([\w-]+)$/); return m && byId(m[1]) ? m[1] : null; };
  const setHash = id => { try { history.replaceState(history.state, '', id ? '#vs-' + id : location.pathname + location.search); } catch {} };
  function openModal(id, source) {
    if (!modal) { location.href = D.productUrl + '#vs-' + (id || 'origin'); return; }
    id = byId(id) ? id : (modalCtl?.current?.id || remembered() || RIVALS[0].id);
    lastFocus = document.activeElement;
    if (!modalCtl) {
      modalCtl = build(modal.querySelector('[data-rc-host]'), 'modal', id2 => setHash(id2));
      modal.addEventListener('cancel', e => { if (modalCtl.escape()) e.preventDefault(); });
      modal.addEventListener('click', e => { if (e.target === modal) modal.close(); });
      modal.addEventListener('keydown', e => modalCtl.keys(e));
      modal.addEventListener('close', () => { modal.classList.remove('is-open'); setHash(null); track('close', {rival: modalCtl.current?.id}); if (lastFocus && document.contains(lastFocus)) lastFocus.focus({preventScroll: true}); });
      modal.querySelector('[data-rc-close]').addEventListener('click', () => modal.close());
    }
    if (!modal.open) modal.showModal();
    requestAnimationFrame(() => modal.classList.add('is-open'));
    modal.querySelector('[data-rc-close]').focus({preventScroll: true});
    modalCtl.start(id); remember(modalCtl.current.id);
    setHash(modalCtl.current.id);
    track('open', {rival: modalCtl.current.id, source});
    return modalCtl;
  }

  document.addEventListener('click', e => {
    const t = e.target.closest('[data-rc-open]');
    if (!t) return;
    e.preventDefault();
    openModal(t.dataset.rcRival || t._rcRival, t.dataset.rcSource || (t.matches('[data-rc-teaser]') ? 'teaser-' + (t.classList.contains('rc-teaser--home') ? 'home' : 'product') : 'link'));
  });

  /* ---------- Cases VS animées ----------
     Chaque concurrent : entrée du pot, choc du VS, comptage des grammes, écart en argent.
     Pause au survol (le temps de lire), hors écran et avec la réduction des mouvements. */
  const TICK = 3200;
  function teaser(el) {
    const ids = [...new Set([remembered(), ...(D.teaser || [])].filter(Boolean))].filter(byId);
    const host = el.querySelector('[data-rc-teaser-pots]');
    host.innerHTML = ids.map(id => `<img src="${esc(byId(id).img)}" alt="" loading="lazy" style="--s:${byId(id).scale}">`).join('');
    const steps = el.querySelector('[data-rc-teaser-steps]');
    steps.innerHTML = ids.map(() => '<i></i>').join('');
    el.style.setProperty('--rc-tick', TICK + 'ms');
    const imgs = [...host.children], dots = [...steps.children];
    const name = el.querySelector('[data-rc-teaser-name]'), g = el.querySelector('[data-rc-teaser-grams]'), fill = el.querySelector('[data-rc-teaser-fill]');
    const rokG = el.querySelector('[data-rc-teaser-rok]'), ratioN = el.querySelector('[data-rc-teaser-ratio-n]');
    const total = grams(ROK);
    let i = -1, timer = null, first = true;
    const next = () => {
      i = (i + 1) % ids.length;
      const p = byId(ids[i]), gp = grams(p);
      imgs.forEach((im, k) => { const was = im.classList.contains('is-on'); im.classList.toggle('is-out', k !== i && was); im.classList.toggle('is-on', k === i); });
      dots.forEach((d, k) => { d.classList.toggle('is-done', k < i); d.classList.toggle('is-on', k === i); });
      el._rcRival = p.id;
      name.textContent = p.name;
      ratioN.textContent = num(total / gp);
      fill.style.transform = 'scaleX(0)';
      requestAnimationFrame(() => requestAnimationFrame(() => { fill.style.transform = `scaleX(${Math.max(.02, gp / total)})`; }));
      setTimeout(() => countTo(g, 0, gp, gramsTxt, 900), reduce ? 0 : 250);
      if (first) { countTo(rokG, 0, total, v => num(v) + U + 'g', 900); first = false; }
      el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
    };
    next();
    if (reduce || ids.length < 2) return;
    /* Chronomètre : le temps ne s'écoule que si la case est visible, non survolée à la souris, l'onglet actif et la fenêtre fermée.
       La pause fige la progression ; la reprise repart du même point. */
    let elapsed = 0, last = 0, raf = 0, visible = false, hover = false;
    const running = () => visible && !hover && !document.hidden && !modal?.open;
    const loop = t => {
      if (!running()) { raf = 0; last = 0; el.classList.add('is-paused'); return; }
      if (last) elapsed += Math.min(t - last, 100);
      last = t;
      const k = Math.min(1, elapsed / TICK);
      el.style.setProperty('--rc-p', k.toFixed(4));
      if (k >= 1) { elapsed = 0; next(); }
      raf = requestAnimationFrame(loop);
    };
    const run = () => { const on = running(); el.classList.toggle('is-paused', !on); if (on && !raf) { last = 0; raf = requestAnimationFrame(loop); } };
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; run(); }, {threshold: .3}).observe(el);
    else { visible = true; run(); }
    document.addEventListener('visibilitychange', run);
    modal?.addEventListener('close', () => setTimeout(run, 50));
    el.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hover = true; run(); } });
    el.addEventListener('pointerleave', e => { if (e.pointerType !== 'mouse') return; hover = false; el.style.setProperty('--rc-rx', '0deg'); el.style.setProperty('--rc-ry', '0deg'); el.style.setProperty('--rc-px', '0px'); run(); });
    /* Inclinaison légère au pointeur (ordinateur) : la case réagit avant le clic */
    if (matchMedia('(hover:hover) and (pointer:fine)').matches) el.addEventListener('pointermove', e => {
      const r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
      el.style.setProperty('--rc-ry', (x * 8).toFixed(2) + 'deg'); el.style.setProperty('--rc-rx', (-y * 8).toFixed(2) + 'deg'); el.style.setProperty('--rc-px', (x * 10).toFixed(1) + 'px');
    });
  }
  document.querySelectorAll('[data-rc-teaser]').forEach(teaser);

  /* ---------- Mur du comparateur (08/10) ----------
     Frise de duels : chaque carte met un pré connu face à ROK, ROK à gauche et en premier (Enzo, 08/10 soir).
     Défile en continu, même au survol (Enzo, 08/10 soir) ; arrêt seulement hors écran et avec la réduction des mouvements.
     Une carte touchée ouvre le comparateur sur ce pré. */
  document.querySelectorAll('[data-rc-wall]').forEach(wall => {
    const rail = wall.querySelector('[data-rc-wall-rail]'), ctx = wall.dataset.rcCtx || 'home';
    const list = (D.wall || []).map(byId).filter(Boolean);
    const pots = list.length ? list : RIVALS.slice(0, 15);
    const count = wall.querySelector('[data-rc-wall-count]'); if (count) count.textContent = RIVALS.length;
    const gR = grams(ROK);
    const card = (p, clone) => { const g = grams(p), lose = g < gR;
      return `<button type="button" class="rc-wall__duel" data-rc-open data-rc-fixed data-rc-rival="${esc(p.id)}" data-rc-source="wall-pot-${ctx}"${clone ? ' tabindex="-1" aria-hidden="true"' : ''} aria-label="${esc(T.wallOpen(p.brand + ' ' + p.name))}">
      <span class="rc-wall__pots"><span class="rc-wall__img rc-wall__img--rok"><img src="${esc(ROK.img)}" alt="" loading="lazy"></span><i>VS</i><span class="rc-wall__img"><img src="${esc(p.img)}" alt="" loading="lazy"></span></span>
      <span class="rc-wall__row is-rok"><small>ROK</small><b>${gramsTxt(gR)}</b></span>
      <span class="rc-wall__bar is-rok"><s style="--f:${Math.min(1, gR / Math.max(g, gR)).toFixed(3)}"></s></span>
      <span class="rc-wall__row${lose ? ' is-lose' : ''}"><small>${esc(p.brand)}</small><b>${gramsTxt(g)}</b></span>
      <span class="rc-wall__bar${lose ? ' is-lose' : ''}"><s style="--f:${Math.min(1, g / gR).toFixed(3)}"></s></span></button>`; };
    rail.innerHTML = `<div class="rc-wall__track">${pots.map(p => card(p, false)).join('')}${reduce ? '' : pots.map(p => card(p, true)).join('')}</div>`;
    if (reduce) { wall.classList.add('is-static'); return; }
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => wall.classList.toggle('is-off', !en.isIntersecting)).observe(wall);
  });

  /* ---------- Page dédiée ---------- */
  const page = document.querySelector('[data-rc-page]');
  if (page) {
    const q = new URLSearchParams(location.search).get('c');
    const fromHandle = (page.dataset.handle || '').match(/^rok-vs-([\w-]+)$/)?.[1];
    const id = [q, hashId(), fromHandle, remembered(), page.dataset.default].find(byId) || RIVALS[0].id;
    const ctl = build(page, 'page', id2 => {
      if (fromHandle) return; /* page « ROK vs X » : l'adresse reste celle de la page */
      try { const u = new URL(location.href); u.searchParams.set('c', id2); u.hash = ''; history.replaceState(history.state, '', u); } catch {}
    });
    ctl.start(id);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') ctl.escape(); else ctl.keys(e); });
    track('page_view', {rival: id});
    let sent = null; try { sent = sessionStorage.getItem('rok-cmp-posted'); sessionStorage.removeItem('rok-cmp-posted'); } catch {}
    if (sent && /customer_posted=true/.test(location.search)) ctl.mailDone();
    return;
  }

  /* ---------- Ouverture par l'adresse : #vs-c4, #compare, retour d'inscription ---------- */
  let posted = null; try { posted = sessionStorage.getItem('rok-cmp-posted'); } catch {}
  if (posted && /customer_posted=true/.test(location.search)) {
    try { sessionStorage.removeItem('rok-cmp-posted'); } catch {}
    openModal(posted, 'signup-return')?.mailDone();
  } else if (hashId() || location.hash === '#compare') {
    openModal(hashId(), 'link');
  }
  addEventListener('hashchange', () => { const id = hashId(); if (!id) return; if (modal?.open && modalCtl) modalCtl.show(id); else openModal(id, 'link'); });
})();
